import { $ } from './utils'

(() => {
  const searchWrapper = $('.site-header .site-search')
  if (!searchWrapper) return

  const searchBtn = $('.toggle-header-search', searchWrapper)
  const searchSection = $('.header-search', searchWrapper)
  const searchForm = $('.search-form', searchWrapper)
  const searchInput = $('.search-field', searchWrapper)
  const searchSubmit = $('.search-submit', searchWrapper)

  searchInput.setAttribute('required', 'required')

  if (!searchBtn || !searchSection || !searchInput) return

  const isSearchSectionToggled = () => searchSection.classList.contains('toggled')

  const toggleSearchSection = () => {
    let toggled = isSearchSectionToggled()
    toggled = !toggled

    searchSection.classList.toggle('toggled')
    toggled
      ? searchSection.removeAttribute('hidden')
      : searchSection.setAttribute('hidden', '')

    searchSection.setAttribute('aria-hidden', toggled ? 'false' : 'true')
    searchBtn.setAttribute('aria-expanded', toggled ? 'true' : 'false')

    searchInput.setAttribute('tabindex', toggled ? 0 : -1)
    searchSubmit.setAttribute('tabindex', toggled ? 0 : -1)

    toggled ? searchInput.focus() : searchBtn.focus()
  }

  const submitSearchForm = () => {
    if (!isSearchSectionToggled()) {
      return false
    }

    searchForm.submit()
  }

  searchBtn.addEventListener('click', () => toggleSearchSection())
  searchForm.addEventListener('submit', (e) => {
    e.preventDefault()
    submitSearchForm()
  })
  searchWrapper.addEventListener('keyup', (e) => {
    if (e.code === 'Escape' && e.target.closest('.search-form')) {
      toggleSearchSection()
    }
  })
})()
